import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles scroll behaviour on SPA navigation:
 *  - If URL contains a hash (e.g. /sobre#farmaceutico-responsavel), scrolls the
 *    matching element into view (React Router doesn't do native anchor scroll).
 *  - Otherwise, scrolls to the top of the page.
 * Mount this once inside <BrowserRouter>, before any <Routes>.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick for the target route to render, then scroll to anchor.
      const id = hash.replace(/^#/, "");
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
        return false;
      };
      if (!tryScroll()) {
        // Element not yet in DOM (route just changed) — retry a few times.
        let attempts = 0;
        const iv = setInterval(() => {
          attempts += 1;
          if (tryScroll() || attempts > 10) clearInterval(iv);
        }, 60);
        return () => clearInterval(iv);
      }
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, hash]);

  return null;
}
